export default class Page {
    constructor() {}
}